<div class="qpoint-main" [ngClass]="{ 'menu-collapsed' : isMenuCollapsed, 'temporary-expanded' : isMenuTemporaryExpanded }">
  <ng-content></ng-content>
</div>
